// eslint-disable-next-line no-undef
const BASE_BACKEND_URL = GLOBAL_CONFIG.REACT_APP_APIM_URL;
// eslint-disable-next-line no-undef
const ENVIRONMENT = GLOBAL_CONFIG.REACT_APP_ENVIRONMENT;

// Base supplier URL
const USER_API_URL = `${BASE_BACKEND_URL}/ibuy-${ENVIRONMENT}-User/user`;

// Autocomplete User URL
const USER_NAME_AUTOCOMPLETE = `${USER_API_URL}/autocomplete`;
export const USER_NAME_AUTOCOMPLETE_GET = (query) => {
    return `${USER_NAME_AUTOCOMPLETE}/${query}`;
};

// Proxy rules
export const USER_PROXY_RULE = `${USER_API_URL}/proxy-rules`;
export const USER_PROXY_RULE_DELETE = (userName) =>
    `${USER_PROXY_RULE}/${userName}`;

// Batch requisition change
export const BATCH_OWNER_UPDATE = (isPreflight) =>
    `${USER_API_URL}/batch-owner-update${
        isPreflight ? "?preflight_check=Y" : ""
    }`;

export const SINGLE_OWNER_UPDATE = () => `${USER_API_URL}/single-owner-update`;

// one time addresses
export const USER_ONETIME_ADDRESSES = `${USER_API_URL}/ota/addresses`;
export const DELETE_ONETIME_ADDRESS = `${USER_API_URL}/ota`;

// search user
export const SEARCH_USER_GET = (query) => {
    const { user_name, person_id } = query;
    const url = new URL("user/search", USER_API_URL);
    if (user_name) url.searchParams.append("user_name", user_name);
    if (person_id) url.searchParams.append("person_id", person_id);
    return url.toString();
};
